import { ToggleGroup, ToggleGroupItem } from "src/components/ui/toggle-group";
import { reportingIntervals } from "src/lib/reportingInterval";

export function ReportingIntervalPicker({ value, onValueChange, disabled }) {
  return (
    <div
      className={
        disabled
          ? "space-y-2 opacity-50 [&_button:disabled]:opacity-100"
          : "space-y-2"
      }
    >
      <span className="text-xs font-medium text-muted-foreground">
        Reporting interval
      </span>
      <ToggleGroup
        type="single"
        value={value}
        onValueChange={(next) => {
          if (next) onValueChange(next);
        }}
        disabled={disabled}
        variant="outline"
        size="sm"
        aria-label="Reporting interval"
        className="h-9 w-full"
      >
        {reportingIntervals.map(({ value, label }) => (
          <ToggleGroupItem
            key={value}
            value={value}
            aria-label={label}
            className="h-9 px-3 text-xs data-[state=on]:bg-primary/10 data-[state=on]:text-primary"
          >
            {label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}
